import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Encyclopedia from 'features/encyclopedia/Encyclopedia'
import type { EncyclopediaProps } from 'features/encyclopedia/types'
import { shuffleArray } from 'utils/helpers'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'
import { mapCmsEncyclopediaArticlesToArticles } from 'utils/cms'

const EncyclopediaPage = (props: EncyclopediaProps) => {
  // Constants
  const { title, description } = props?.content
  const SEO: SeoProps = {
    description: props?.content?.seo?.metaDescription ?? description,
    image: props?.content?.seo?.seoImage?.url,
    title: props?.content?.seo?.seoTitle ?? title
  }

  return (
    <Layout seo={SEO}>
      <Encyclopedia {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  try {
    // Fetch the data
    const [content, categories, encyclopediaArticles] = await Promise.all([
      cmsLib.getEncyclopediaPage(),
      cmsLib.getEncyclopediaCategories(),
      cmsLib.getEncyclopediaArticles()
    ])

    // Convert the articles (for filtering & using in the components)
    const articles = mapCmsEncyclopediaArticlesToArticles(encyclopediaArticles)

    // Get highlighted article & popular articles
    const filteredArticles = articles.filter((article) => article.isPopular)
    const popularArticles = shuffleArray(filteredArticles).slice(0, 4)

    return {
      props: {
        categories,
        content: content || null,
        popularArticles,
        ...(await serverSideTranslations(locale, DEFAULT_NAMESPACES, i18nConfig))
      },
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  } catch (_) {
    return {
      props: {
        articles: [],
        categories: []
      },
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  }
}

export default EncyclopediaPage
